import React from "react";
import ReactMarkdown from "react-markdown";

export default function DocumentBlock({ content, id}) {
	return (
		<div id={id} ><ReactMarkdown>{content}</ReactMarkdown></div>
	);
}
